import barba from '@barba/core';
import views from './views/views';
import transitions from './transitions/transitions';
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class Spa {
	constructor() {

		barba.hooks.leave(({ current, next, trigger }) => {
			// document.dispatchEvent(new CustomEvent('remove-cursors'));
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			if (history.scrollRestoration) {
				history.scrollRestoration = 'manual';
			}

			const triggers = ScrollTrigger.getAll();
			triggers.forEach(trigger => {
				trigger.kill();

				// Aww merr gawd.. 1 volle labs dag verder.
				// Shame.. na een dag zoeken is dit de beste oplossing. Wellicht eens kijken of dit weg kan als er een nieuwe versie van gsap/scrollTrigger is
				trigger.scroll.rec = null;
				const lelijk = setInterval(() => {
					if(trigger.scroll.rec !== null){
						trigger.scroll.rec = null;
					}
				}, 10);
			});

			const blessEvent = new Event('bless', {
				bubbles: true,
			});

			next.container.dispatchEvent(blessEvent);
		});

		barba.hooks.after(({ current, next, trigger }) => {
			//
		});

		// Barba settings, transitions and views
		barba.init({
			debug: window.WPDATA.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				if (/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(href)) {
					return true;
				}
			},
			views: views,
			transitions: transitions,
		});

	}
}
